export class ResetError extends Error {
    constructor(message: string, options: ErrorOptions = {}) {
        super(message, options)
        this.name = 'ResetError'
    }
}

export class SubscriptionError extends Error {
    constructor(message: string, options: ErrorOptions = {}) {
        super(message, options)
        this.name = 'SubscriptionError'
    }
}